//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "GlasgowBlatchford",
  data() {
    return {
      gender: "",
      hemoglobin1: "",
      hemoglobin2: "",
      form: {
        Urea_nitrogen: "",
        shrink_pressure: "",
        Heart_rate: "0",
        melena: "0",
        swoon: "0",
        Liver_disease: "0",
        Heart_failure: "0",
      },
      dataList1: [
        { value: '0', name: '男' },
        { value: '1', name: '女' }
      ],
      dataList2: [
        { value: '0', name: '≥130' },
        { value: '1', name: '≥120且＜130' },
        { value: '3', name: '≥100且＜120' },
        { value: '6', name: '＜100' }
      ],
      dataList3: [
        { value: '0', name: '≥120' },
        { value: '1', name: '≥100且＜120' },
        { value: '6', name: '＜100' }
      ],
      dataList4: [
        { value: '0', name: '<6.5' },
        { value: '2', name: '≥6.5且＜8.0' },
        { value: '3', name: '≥8且＜10' },
        { value: '4', name: '≥10且＜25' },
        { value: '6', name: '≥25' }
      ],
      dataList5: [
        { value: '0', name: '≥110' },
        { value: '1', name: '100~109' },
        { value: '2', name: '90~99' },
        { value: '3', name: '＜90' }
      ],
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        form.swoon = form.swoon == 1 ? 2 : 0;
        form.Liver_disease = form.Liver_disease == 1 ? 2 : 0;
        form.Heart_failure = form.Heart_failure == 1 ? 2 : 0;
        let result = (self.gender === '0' ? Number(self.hemoglobin1) : Number(self.hemoglobin2)) + form.Urea_nitrogen + form.shrink_pressure + form.Heart_rate + form.melena + form.swoon + form.Liver_disease + form.Heart_failure;
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/GlasgowBlatchford.vue